<script lang="ts" context="module">
    import type { ModalSettings, ModalStore } from "@skeletonlabs/skeleton";

    export async function triggerError(modalStore: ModalStore, resp: Response) {
        const err = await resp.json();
        const modal: ModalSettings = {
            type: "component",
            component: "error",
            body: err.message,
            meta: { status: resp.status, code: err.code },
        };
        modalStore.trigger(modal);
    }

    export async function triggerErrorMessage(modalStore: ModalStore, msg: string) {
        const modal: ModalSettings = {
            type: "component",
            component: "error",
            body: msg,
        };
        modalStore.trigger(modal);
    }
</script>

<script lang="ts">
    import { getModalStore } from "@skeletonlabs/skeleton";

    const modalStore = getModalStore();
</script>

{#if $modalStore[0]}
    <div class="bg-white p-8 rounded-lg flex flex-col place-items-center gap-10">
        <header class="font-semibold text-3xl">Error</header>
        {#if $modalStore[0].meta?.status === 500}
            <p>A bug report has been filed</p>
        {:else}
            <p>{$modalStore[0].body}</p>
        {/if}
    </div>
{/if}
